import ASwitch from './Switch.vue';
export default ASwitch;


// WEBPACK FOOTER //
// ./src/packages/Switch/index.js